import { render, staticRenderFns } from "./SpinnerFull.vue?vue&type=template&id=e996e5ae&scoped=true&"
import script from "./SpinnerFull.vue?vue&type=script&lang=ts&"
export * from "./SpinnerFull.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerFull.vue?vue&type=style&index=0&id=e996e5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996e5ae",
  null
  
)

export default component.exports